import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import btnAttachment from '../Common/Images/btnAttachment.png';
import Loading from '../Common/Loading';
import checkImg from '../Common/Images/check.gif';
import ReactQuill, { Quill } from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import alert_A_bg from '../Common/Images/ImagesForAlert/alert_A_bg.png';
import alert_close_n from '../Common/Images/ImagesForAlert/alert_close_n.png';
import ok_n from '../Common/Images/ImagesForAlert/ok_n.png';
import ok_o from '../Common/Images/ImagesForAlert/ok_o.png';
import { createRoot } from "react-dom/client";

import alert_T_bg_medium from '../Common/Images/ImagesForAlert/alert_T_bg_medium.png';
import Now_n from '../Common/Images/ImagesForAlert/Now_n.png';
import Now_o from '../Common/Images/ImagesForAlert/Now_o.png';
import Later_n from '../Common/Images/ImagesForAlert/Later_n.png';
import Later_o from '../Common/Images/ImagesForAlert/Later_o.png';
import alert_close_o from '../Common/Images/ImagesForAlert/alert_close_o.png';
import okv_n from '../Common/Images/ImagesForAlert/okv_n.png';
import cancelv_n from '../Common/Images/ImagesForAlert/cancelv_n.png';

const fontSizeArr = ['0', '1', '2', '3', '4', '5', '6', '7'];

const Size = Quill.import('attributors/class/size') as any;
Size.whitelist = fontSizeArr;
Quill.register(Size, true);

const fontsArr = [
    'arial',
    'calibri',
    'comic-sans-ms',
    'courier-new',
    'tahoma',
    'times-new-roman',
    'trebuchet-ms',
    'verdana'
];
const Font = Quill.import('attributors/class/font') as any;
Font.whitelist = fontsArr;
Quill.register(Font, true);

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

interface Student {
    id: string;
    firstName: string;
    gender: string;
    grade: string;
    learningDifficulty: string | null;
    isLoggedIn: boolean;
    isSelective: boolean;
}



interface CustomerDetails {
    surname: string;
    parentsName: string;
    address: string;
    suburb: string;
    postcode: string;
    state: string;
    phone: string;
    mobile1: string;
    mobile2: string;
    email: string;
    dateOfSale: string;
    packages: string;
    distributor: string;
    paymentDue: boolean;
    localTime?: string;
    lastAccessOn?: string;
    notifyOnUsage?: boolean;
}

interface Task {
    problemId: number;
    description: string;
    from: string;
    to: string;
    enteredDate: string;
    actionDate: string;
    isFixed: boolean;
    type: string;
    reason: string;
    outcome: string;
    timeSpent: string;
    hasAttachment: boolean;
    attachments: Attachment[];
}

interface Attachment {
    docName: string;
    fileName: string;
    url?: string;
}

interface DropdownItem {
    value: string;
    label: string;
}

interface Dropdowns {
    staff_members: any[];
    problem_types: string[];
    problem_types_data: any[];
    call_outcomes: string[];
    reasons: string[];
}

interface PageData {
    customer: CustomerDetails;
    students: Student[];
    tasks: Task[];
    staffMembers: DropdownItem[];
    problemTypes: DropdownItem[];
    callOutcomes: DropdownItem[];
    reasons: DropdownItem[];
    tutorLogin: string;
    dropdowns: Dropdowns;
    canResetPassword: boolean;
}

const styles = {
    container: {
        fontFamily: 'Arial, Helvetica, sans-serif',
        fontSize: '11pt',
        backgroundColor: '#E8E8FF',
        padding: '5px',
        position: 'fixed' as 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column' as 'column',
        overflow: 'hidden'
    },
    table: { width: '100%', borderCollapse: 'collapse' as 'collapse', border: '1px solid gray', marginBottom: '5px' },
    th: { border: '1px solid gray', backgroundColor: '#E8E8FF', padding: '3px', textAlign: 'left' as 'left', fontWeight: 'bold' },
    td: { border: '1px solid gray', padding: '3px', verticalAlign: 'top' },
    blueHeader: { backgroundColor: '#E8E8FF', color: '#000000', border: '1px solid #000000', fontFamily: 'Calibri', fontWeight: 'bold', fontSize: '11pt', padding: '3px', textAlign: 'left' as 'left' },
    button: { backgroundColor: '#ccccff', border: '1px solid blue', cursor: 'pointer', fontSize: '11pt', fontFamily: 'Arial', fontWeight: 'bold', padding: '2px 5px', marginRight: '5px' },
    actionButton: { backgroundColor: 'orange', border: '1px solid blue', cursor: 'pointer', fontSize: '11pt', fontFamily: 'Arial', padding: '2px 5px', marginRight: '8px', marginBottom: '4px' },
    popupMenu: { position: 'absolute' as 'absolute', backgroundColor: 'white', border: '1px solid black', color: 'blue', fontSize: '10pt', zIndex: 9999, width: '240px', boxShadow: '2px 2px 5px rgba(0,0,0,0.2)', cursor: 'pointer' },
    menuItem: { padding: '5px', borderBottom: '1px solid #cccccc', cursor: 'pointer', transition: 'background-color 0.2s ease' },
    menuItemHovered: { padding: '5px', borderBottom: '1px solid #cccccc', cursor: 'pointer', backgroundColor: 'rgb(257,211,37', transition: 'background-color 0.2s ease' },
    editor: { width: '100%', height: '65px', border: '1px solid gray', overflowY: 'auto' as 'auto', fontFamily: 'Arial', fontSize: '10pt', backgroundColor: 'white' },
    headerRow: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        backgroundColor: '#E8E8FF',
    },
    col1: { width: '30%' },
    col2: {
        paddingLeft: '10px',
        width: '60%',
        textAlign: 'center' as 'center',
        color: '#0066CC',
        fontFamily: 'Trebuchet MS',
        fontSize: '18px',
        fontWeight: 'bold'
    },
    col3: {
        paddingRight: '5px',
        width: '40%',
        fontSize: '12pt',
        display: 'flex',
        alignItems: 'center',
        fontFamily: 'Arial',
        fontWeight: 'bold',
        color: 'black'
    },
    col4: {
        width: '30%',
        paddingRight: '15px',
        fontSize: '12pt',
        fontWeight: 'bold',
        margin: '5px',
        textAlign: 'right' as 'right'
    },
    disabledOverlay: {
        position: 'fixed' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.2)',
        zIndex: 99999,
        cursor: 'wait'
    }
};

const editorModules = {
    toolbar: [
        [{ font: [false, ...fontsArr] }, { size: [false, ...fontSizeArr] }],
        ['bold', 'italic', 'underline'],
        [{ color: [] }, { background: [] }],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{ list: 'ordered' }, { list: 'bullet' }]
    ],
};

const customQuillStyles = `
    .quill {
        background-color: #EEEEEE;
        width: 100% !important;
        display: flex;
        flex-direction: column;
        table-layout: fixed;
        box-sizing: border-box;
    }

    .ql-toolbar {
        padding: 2px !important;
        display: flex !important;
        flex-wrap: wrap !important;
        align-items: center;
        gap: 2px;
        white-space: normal !important;
        overflow: visible !important;
        position: relative;
        z-index: 999;
        width: 100%;
        box-sizing: border-box;
    }

    .ql-formats {
        margin-right: 4px !important;
        margin-bottom: 2px !important;
        display: flex;
        align-items: center;
    }

    .ql-picker {
        position: relative !important;
        padding-left: 4px !important;
    }
    .ql-snow .ql-picker.ql-size {
        width: 40px !important;
    }

    .ql-picker-label {
        padding-left: 4px !important;
    }

    .ql-container {
        min-height: 75px !important;
        height: 75px !important;
        width: 100% !important;
        font-family: Arial, sans-serif !important;
        font-size: 10pt !important;
        overflow: visible !important;
        box-sizing: border-box;
    }

    .ql-editor {
        min-height: 50px;
        max-height: 145px;
        font-family: Arial, sans-serif !important;
        font-size: 10pt !important;
        color: #000000 !important;
        background-color: white;
        white-space: pre-wrap !important;
        overflow-wrap: anywhere !important;
        word-break: break-word !important;
        overflow-y: auto !important;
        padding: 8px !important;
        box-sizing: border-box;
        font-weight: normal !important;
    }

    .ql-editor p,
    .ql-editor span,
    .ql-editor div,
    .ql-editor li {
        font-size: 10pt !important;
        font-weight: normal !important;
        margin: 0 !important;
    }

    /* Reset margins for rendered history descriptions so pasted/entered
       content does not keep left indentation (eg. margin-left:5%) */
   .history-description-cell,
.history-description-cell p,
.history-description-cell div,
.history-description-cell span,
.history-description-cell li {
    font-family: Arial, sans-serif;
    font-size: 10pt;
    font-weight: normal;
    margin: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
}

/* Only real formatting shows as bold */
.history-description-cell strong,
.history-description-cell b {
    font-weight: bold !important;
}
.history-description-cell em,
.history-description-cell i {
    font-style: italic;
}
.history-description-cell u {
    text-decoration: underline;
}

    .ql-picker-options {
        position: absolute !important;
        top: 100% !important;
        bottom: auto !important;
        left: 0 !important;
        z-index: 99999 !important;
        background: white !important;
        border: 1px solid #ccc !important;
        max-height: 200px;
        overflow-y: auto;
    }

    .ql-font-arial {
        font-family: 'Arial', sans-serif;
    }

    .ql-font-calibri {
        font-family: 'Calibri', sans-serif;
    }

    .ql-font-comic-sans-ms {
        font-family: 'Comic Sans MS', cursive, sans-serif;
    }

    .ql-font-courier-new {
        font-family: 'Courier New', monospace;
    }

    .ql-font-tahoma {
        font-family: 'Tahoma', sans-serif;
    }

    .ql-font-times-new-roman {
        font-family: 'Times New Roman', serif;
    }

    .ql-font-trebuchet-ms {
        font-family: 'Trebuchet MS', sans-serif;
    }

    .ql-font-verdana {
        font-family: 'Verdana', sans-serif;
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="arial"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="arial"]::before {
        content: "Arial";
        font-family: "Arial";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="calibri"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="calibri"]::before {
        content: "Calibri";
        font-family: "Calibri";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="comic-sans-ms"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="comic-sans-ms"]::before {
        content: "Comic Sans MS";
        font-family: "Comic Sans MS";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="courier-new"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="courier-new"]::before {
        content: "Courier New";
        font-family: "Courier New";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="tahoma"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="tahoma"]::before {
        content: "Tahoma";
        font-family: "Tahoma";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="times-new-roman"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="times-new-roman"]::before {
        content: "Times New Roman";
        font-family: "Times New Roman";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="trebuchet-ms"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="trebuchet-ms"]::before {
        content: "Trebuchet MS";
        font-family: "Trebuchet MS";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="verdana"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="verdana"]::before {
        content: "Verdana";
        font-family: "Verdana";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=""]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=""]::before {
        content: "Arial";
        font-family: "Arial";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
        content: attr(data-value) !important;
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=""]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=""]::before {
        content: "Normal" !important;
    }

    .ql-size-0 {
        font-size: 8pt;
    }

    .ql-size-1 {
        font-size: 9pt;
    }

    .ql-size-2 {
        font-size: 10pt;
    }

    .ql-size-3 {
        font-size: 12pt;
    }

    .ql-size-4 {
        font-size: 14pt;
    }

    .ql-size-5 {
        font-size: 18pt;
    }

    .ql-size-6 {
        font-size: 24pt;
    }

    .ql-size-7 {
        font-size: 36pt;
    }

    /* Tablet */
    @media (max-width: 992px) {
        .ql-toolbar {
            flex-wrap: wrap !important;
        }

        .ql-snow .ql-picker.ql-font {
            width: 90px !important;
        }

        .ql-snow .ql-picker.ql-size {
            width: 55px !important;
        }
    }

    /* Mobile */
    @media (max-width: 768px) {
        .ql-toolbar {
            font-size: 11px;
            padding: 1px !important;
        }

        .ql-toolbar button {
            width: 22px !important;
            height: 22px !important;
            padding: 2px !important;
        }

        .ql-snow .ql-picker.ql-font {
            width: 80px !important;
        }

        .ql-snow .ql-picker.ql-size {
            width: 50px !important;
        }
    }

    /* Very Small Mobile */
    @media (max-width: 480px) {
        .ql-toolbar {
            flex-wrap: nowrap !important;
            overflow-x: auto !important;
        }

        .ql-container {
            height: 100px !important;
        }
    }
`;

const formatDate = (dateString: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB'); // DD/MM/YYYY
};

const enteredFormatDate = (dateString: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    const time = date.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
    return `${day} ${month} ${year} ${time}`;
};

const normalizeData = (apiResult: any, lParam: string): PageData => {
    const rawCust = apiResult.customer || {};
    const flags = apiResult.flags || {};

    const customer: CustomerDetails = {
        surname: rawCust.surname || '',
        parentsName: rawCust.parents_name || '',
        address: rawCust.address || '',
        suburb: rawCust.suburb || '',
        postcode: rawCust.postcode || '',
        state: rawCust.state || '',
        phone: rawCust.phone || '',
        mobile1: rawCust.mobile1 || '',
        mobile2: rawCust.mobile2 || '',
        email: rawCust.email || '',
        dateOfSale: rawCust.date_of_sale || '',
        packages: rawCust.packages || '',
        distributor: rawCust.distributor || '',
        paymentDue: flags.payment_due || rawCust.paymentDue || false,
        localTime: rawCust.localTime || '',
        lastAccessOn: rawCust.lastAccessOn || '',
        notifyOnUsage: rawCust.notifyOnUsage || false
    };

    const students: Student[] = (apiResult.students || []).map((s: any) => ({
        id: s.id || '',
        firstName: s.first_name || '',
        gender: s.gender || '',
        grade: s.grade || '',
        learningDifficulty: s.learning_difficulty || null,
        isLoggedIn: s.is_logged_in || false,
        isSelective: s.is_selective || false
    }));

    const tasks: Task[] = (apiResult.history || []).map((t: any) => ({
        problemId: t.ProblemID,
        description: t.Description,
        from: t.FromLogin,
        to: t.ToLogin,
        enteredDate: t.EnteredDate,
        actionDate: t.ActionDate,
        isFixed: t.Fixed === true,
        type: t.TypeOfIssue,
        reason: t.Reason,
        outcome: t.CallOutcome,
        timeSpent: t.TimeSpent,
        hasAttachment: (t.AttachCount && t.AttachCount > 0) || false,
        attachments: Array.isArray(t.Attachments) ? t.Attachments : []
    }));

    const dd = apiResult.dropdowns || {};

    const mapDD = (list: any[]) => (list || []).map(i => {
        if (typeof i === 'string') return { value: i, label: i };
        return { value: String(i.value || ''), label: String(i.label || '') };
    });

    return {
        customer,
        students,
        tasks,
        staffMembers: mapDD(dd.staff_members),
        problemTypes: mapDD(dd.problem_types),
        callOutcomes: mapDD(dd.call_outcomes),
        reasons: mapDD(dd.reasons),
        dropdowns: dd,
        tutorLogin: apiResult.tutorLogin || lParam || '',
        canResetPassword: !!flags.can_reset_password,
    };
};

const EL_AddEditTask: React.FC = () => {
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const schoolCode = searchParams.get('SchoolCode') || '';
    const familyCode = searchParams.get('FamilyCode') || '';
    const login = searchParams.get('Login') || '';
    const sParam = searchParams.get('S') || '';
    const fParam = searchParams.get('F') || '';
    const lParam = searchParams.get('L') || '';
    const fromCourtesyCall = searchParams.get('FromCourtesyCall') || '';
    const filterType = searchParams.get('FilterType') || '';
    const minor = searchParams.get('Minor') || '';
    const selectedRow = searchParams.get('SelectedRow') || '';
    const ddlCountryState = searchParams.get('ddlCountryState') || '';
    const rowsPerPage = searchParams.get('RowsperPage') || '';
    const startRecNo = searchParams.get('StartRecNo') || '';
    const calledFrom = searchParams.get('CalledFrom') || '';

    const [data, setData] = useState<PageData | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [attachments, setAttachments] = useState<Attachment[]>([]);
    const attachmentSessionRef = React.useRef(1);
    const quillRef = useRef<ReactQuill | null>(null);

    const [description, setDescription] = useState<string>('');
    const [selectedTo, setSelectedTo] = useState<string>('');
    const [actionDate, setActionDate] = useState<string>(new Date().toISOString().split('T')[0]);
    const [selectedType, setSelectedType] = useState<string>('');
    const [selectedOutcome, setSelectedOutcome] = useState<string>('');
    const [selectedReason, setSelectedReason] = useState<string>('');
    const [timeSpent, setTimeSpent] = useState<string>('');
    const [isFixed, setIsFixed] = useState<boolean>(false);
    const [typeMapping, setTypeMapping] = useState<any[]>([]);
    const [reasonOptions, setReasonOptions] = useState<string[]>([]);
    const [selectedStudent, setSelectedStudent] = useState<string>('');
    const [whiteboardLink, setWhiteboardLink] = useState('');
    const [shareConfirmation, setShareConfirmation] = useState<'link' | 'currentScreen' | null>(null);
    const [currentScreenAnswered, setCurrentScreenAnswered] = useState(true);
    const [showAlertDialog, setShowAlertDialog] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [isOkHovered, setIsOkHovered] = useState(false);
    const [showMDTimeConfirm, setShowMDTimeConfirm] = useState(false);
    const [showECTimeConfirm, setShowECTimeConfirm] = useState(false);
    const [isNowHovered, setIsNowHovered] = useState(false);
    const [isLaterHovered, setIsLaterHovered] = useState(false);
    const [alertPos, setAlertPos] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
    const [studentForLD, setStudentForLD] = useState<string | null>(null);
    const [selectedEmailSubject, setSelectedEmailSubject] = useState<string | null>(null);
    const [showEmailConfirmDialog, setShowEmailConfirmDialog] = useState<boolean>(false);

    const [activePopup, setActivePopup] = useState<string | null>(null);
    const [popupPos, setPopupPos] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
    const [hoveredMenuItem, setHoveredMenuItem] = useState<string | null>(null);

    useEffect(() => {
        if (description !== '') return;

        const frameId = window.requestAnimationFrame(() => {
            const quill = quillRef.current?.getEditor();
            if (quill && quill.getLength() <= 1) {
                quill.format('color', '#000000');
                quill.format('size', 1);
                quill.format('font', 'times-new-roman')
            }
        });

        return () => window.cancelAnimationFrame(frameId);
    }, [description]);

    useEffect(() => {
        if (!activePopup) return;
        const handleClickOutside = () => setActivePopup(null);
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, [activePopup]);

    useEffect(() => {
        if (data && data.customer && data.customer.surname) {
            sessionStorage.setItem('surname', data.customer.surname);
        }
    }, [data]);

    // Opens a window WITHOUT locking this page (no overlay, no polling).
    const openBlockedWindow = (url: string, title: string, features: string) => {
        window.open(url, title, features);
    };

    const handleNewMSR = async () => {
        // ============================================================
        // OPEN POPUP IMMEDIATELY
        // Must happen synchronously from the button click
        // ============================================================
        const width = 650;
        const height = 800;

        const left = (window.screen.availWidth - width) / 2;
        const top = (window.screen.availHeight - height) / 2;

        const features = [
            `width=${width}`,
            `height=${height}`,
            `left=${left}`,
            `top=${top}`,
            'toolbar=no',
            'location=no',
            'directories=no',
            'status=no',
            'menubar=no',
            'scrollbars=yes',
            'resizable=yes',
        ].join(',');

        const newWindow = window.open(
            '',
            'SelectUser',
            features
        );

        // Popup blocked
        if (!newWindow) {
            console.error("Popup was blocked by browser.");
            setAlertMessage(
                "Please allow popups for this website and try again."
            );
            setShowAlertDialog(true);
            return;
        }

        // Optional loading message inside popup
        newWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
        <title>Select User</title>
    </head>
    <body style="margin: 0;">
        <div id="loading-root"></div>
    </body>
    </html>
`);

        newWindow.document.close();

        const loadingRoot = newWindow.document.getElementById("loading-root");

        if (loadingRoot) {
            createRoot(loadingRoot).render(<Loading />);
        }

        try {
            if (!schoolCode || !familyCode || !lParam) {
                console.error(
                    "Missing SchoolCode, FamilyCode or Family Login",
                    {
                        schoolCode,
                        familyCode,
                        familyLogin: lParam
                    }
                );

                newWindow.close();
                return;
            }

            // ============================================================
            // SELECT USER PARAMETERS
            // ============================================================
            const params = new URLSearchParams({
                SchoolCode: schoolCode,
                FamilyCode: familyCode,
            }).toString();

            // ============================================================
            // GENERATE SSO URL
            // ============================================================
            const response = await fetch(
                `${API_BASE_URL}api/generate-sso-url/`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        // Family login
                        login: login,

                        schoolcode: schoolCode,
                        familycode: familyCode,

                        // Destination
                        page: "Login/SelectUser",

                        // Parameters required by SelectUser
                        params: params,
                    }),
                }
            );

            const data = await response.json();

            if (!response.ok || !data.success || !data.url) {
                console.error(
                    "Failed to generate SSO URL:",
                    data
                );

                newWindow.close();
                return;
            }

            // ============================================================
            // LOAD SSO URL INSIDE THE NEW WINDOW
            // ============================================================
            newWindow.location.href = data.url;

            // Bring popup to front
            newWindow.focus();

        } catch (error) {
            console.error("New MSR SSO error:", error);

            newWindow.close();
        }
    };



    const openPopup = (url: string, title: string, w: number, h: number) => {
        const left = (window.screen.width / 2) - (w / 2);
        const top = (window.screen.height / 2) - (h / 2);

        const features = `toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,copyhistory=no,width=${w},height=${h},top=${top},left=${left}`;

        openBlockedWindow(url, title, features);
    };

    useEffect(() => {
        (window as any).handleAttachments = (docs: Attachment[], session?: number) => {
            if (session && session !== attachmentSessionRef.current) return;
            setAttachments(Array.isArray(docs) ? docs : []);
        };
        return () => {
            delete (window as any).handleAttachments;
        };
    }, []);

    const handleAlertMouseDown = (e: React.MouseEvent) => {
        setIsDragging(true);
        setDragOffset({
            x: e.clientX - alertPos.x,
            y: e.clientY - alertPos.y
        });
    };

    const handleAlertMouseMove = useCallback((e: MouseEvent) => {
        if (isDragging) {
            setAlertPos({
                x: e.clientX - dragOffset.x,
                y: e.clientY - dragOffset.y
            });
        }
    }, [isDragging, dragOffset]);

    const handleAlertMouseUp = () => {
        setIsDragging(false);
    };

    useEffect(() => {
        if (isDragging) {
            window.addEventListener('mousemove', handleAlertMouseMove);
            window.addEventListener('mouseup', handleAlertMouseUp);
        } else {
            window.removeEventListener('mousemove', handleAlertMouseMove);
            window.removeEventListener('mouseup', handleAlertMouseUp);
        }
        return () => {
            window.removeEventListener('mousemove', handleAlertMouseMove);
            window.removeEventListener('mouseup', handleAlertMouseUp);
        };
    }, [isDragging, handleAlertMouseMove]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const params = new URLSearchParams({
                SchoolCode: schoolCode || '',
                FamilyCode: familyCode || '',
                Login: login || '',
                S: sParam,
                F: fParam,
                L: lParam
            });

            const response = await fetch(`${API_BASE_URL}api/get_support_task_data/?${params.toString()}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) throw new Error(`HTTP Error: ${response.status}`);
            const result = await response.json();
            if (result.error) throw new Error(result.error);

            const normalized = normalizeData(result, lParam);
            setData(normalized);

            if (result.dropdowns && result.dropdowns.problem_types_data) {
                setTypeMapping(result.dropdowns.problem_types_data);

                if (minor) {
                    setSelectedType(minor);
                    const matchingType = result.dropdowns.problem_types_data.find((t: any) => t.type === minor);
                    if (matchingType && matchingType.reasons) {
                        setReasonOptions(matchingType.reasons);
                    }
                }
            }

        } catch (err: any) {
            console.error("Fetch Error:", err);
            setError(err.message || 'Error loading task data');
        } finally {
            setLoading(false);
        }
    };

    // const handleBack = () => {
    //     if (fromCourtesyCall === 'Y') {
    //         window.close();
    //     } else if (calledFrom === 'FlagedAlertList') {
    //         const backParams = new URLSearchParams({
    //             S: sParam,
    //             F: fParam,
    //             L: lParam,
    //             Minor: minor,
    //             SelectedRow: selectedRow,
    //             ddlCountryState: ddlCountryState,
    //             RowsperPage: rowsPerPage,
    //             StartRecNo: startRecNo
    //         });
    //         navigate(`/SUPPORT/EL_FlagedAlertList?${backParams.toString()}`);
    //     } else if (location.state?.returnPath) {
    //         navigate(location.state.returnPath, {
    //             replace: true
    //         });
    //     } else {
    //         navigate(-1);
    //     }
    // };


    // /SUPPORT/EL_ListOfTasks?FilterType=${encodeURIComponent(filterType)}&S=${encodeURIComponent(S)}&F=${encodeURIComponent(F)}&L=${encodeURIComponent(L)}`;
    const handleBack = () => {
        const S = sessionStorage.getItem("S") || '';
        const F = sessionStorage.getItem("F") || '';
        const L = sessionStorage.getItem("L") || '';

        navigate(`/SUPPORT/EL_ListOfTasks?FilterType=${encodeURIComponent(filterType)}&S=${encodeURIComponent(S)}&F=${encodeURIComponent(F)}&L=${encodeURIComponent(L)}`);
    }

    useEffect(() => {
        (window as any).updateLearningDifficulty = async (difficulty: string) => {

            if (!studentForLD) {
                setAlertMessage("Student ID is lost. Please close popup and try again.");
                setShowAlertDialog(true);
                return;
            }

            if (!schoolCode || !login) {
                setAlertMessage("Missing SchoolCode or FamilyCode in URL.");
                setShowAlertDialog(true);
                return;
            }

            setLoading(true);
            try {
                const payload = {
                    school_code: schoolCode,
                    family_code: login,
                    login: studentForLD,
                    learning_difficulty: difficulty
                };

                const response = await fetch(`${API_BASE_URL}api/support/update-student-ld/`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload)
                });

                const result = await response.json();

                if (!response.ok) throw new Error(result.error || 'Failed to update');

                await fetchData();
                setAlertMessage("Learning Difficulty updated successfully.");
                setShowAlertDialog(true);

            } catch (error) {
                console.error("LD Update Error:", error);
                setAlertMessage(`Failed to update: ${error}`);
                setShowAlertDialog(true);
            } finally {
                setLoading(false);
                setStudentForLD(null);
            }
        };

        return () => {
            delete (window as any).updateLearningDifficulty;
        };
    }, [studentForLD, schoolCode, login]);

    const handleTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newType = e.target.value;
        setSelectedType(newType);

        setSelectedReason('');

        const typeData = typeMapping.find((t: any) => t.type === newType);

        if (typeData && typeData.reasons) {
            setReasonOptions(typeData.reasons);
        } else {
            setReasonOptions([]);
        }
    };

    useEffect(() => {
        if (schoolCode && familyCode) fetchData();
    }, [schoolCode, familyCode, login, sParam, fParam, lParam]);

    const handlePopupClick = (e: React.MouseEvent, menuName: string) => {
        if (!selectedStudent || selectedStudent === '-Select-') {
            setAlertMessage(`Please select a student.`);
            setShowAlertDialog(true);
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        const rect = (e.target as HTMLElement).getBoundingClientRect();
        setPopupPos({ top: rect.bottom + window.scrollY + 2, left: rect.left + window.scrollX });
        setActivePopup(activePopup === menuName ? null : menuName);
    };

    const handlePopupClickN = (e: React.MouseEvent, menuName: string) => {
        if (menuName === 'Share' && (!selectedStudent || selectedStudent === '-Select-' || selectedStudent === '0')) {
            setAlertMessage('Please select a student to enable Sharing.');
            setShowAlertDialog(true);
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        const rect = (e.target as HTMLElement).getBoundingClientRect();
        setPopupPos({ top: rect.bottom + window.scrollY + 2, left: rect.left + window.scrollX });
        setActivePopup(activePopup === menuName ? null : menuName);
    };

    const handleStudentClick = (student: Student) => {
        setStudentForLD(student.id);

        const width = 500;
        const height = 450;
        const left = (window.screen.width / 2) - (width / 2);
        const top = (window.screen.height / 2) - (height / 2);

        const currentLD = student.learningDifficulty || '';
        const url = `/Support/EL_SelectLearningDifficulty?LearningDifficulty=${encodeURIComponent(currentLD)}`;

        openBlockedWindow(
            url, 'SelectLearningDifficulty', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`
        );
    };

    const handleMDStats = () => {
        const width = window.screen.availWidth - 100;
        const height = window.screen.availHeight - 100;

        const left = (window.screen.availWidth - width) / 2;
        const top = (window.screen.availHeight - height) / 2;

        const url = `/Support/EL_MDStatus?C=${encodeURIComponent(schoolCode)}&F=${encodeURIComponent(login)}&T=${encodeURIComponent(lParam)}`;

        openBlockedWindow(
            url,
            'MDStatus',
            `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`
        );
    };

    const handleStatusChange = async (problemId: number, currentStatus: boolean) => {
        const isConfirmed = window.confirm("You want to Update?");
        if (!isConfirmed) {
            return;
        }

        const newStatus = !currentStatus;
        const statusValue = newStatus ? '1' : '0';

        setLoading(true);

        setData((prevData: any) => {
            if (!prevData) return prevData;

            if (!Array.isArray(prevData.history)) {
                console.warn("History array is missing in state:", prevData);
                return prevData;
            }

            return {
                ...prevData,
                history: prevData.history.map((task: Task) =>
                    task.problemId === problemId ? { ...task, isFixed: newStatus } : task
                )
            };
        });

        try {
            const params = new URLSearchParams({
                ProblemID: problemId.toString(),
                Fixed: statusValue
            });

            const response = await fetch(`${API_BASE_URL}api/update_support_status/?${params.toString()}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            });

            if (!response.ok) {
                throw new Error("Failed to update status");
            }

        } catch (error) {
            console.error("Error updating status:", error);
            setAlertMessage("Failed to update status. Reverting change.");
            setShowAlertDialog(true);

            setData((prevData: any) => {
                if (!prevData || !Array.isArray(prevData.history)) return prevData;

                return {
                    ...prevData,
                    history: prevData.history.map((task: Task) =>
                        task.problemId === problemId ? { ...task, isFixed: currentStatus } : task
                    )
                };
            });
        } finally {
            setLoading(false);
            fetchData();
        }
    };

    const handleSaveTask = async () => {
        if (!selectedTo) {
            setAlertMessage('Please select to whom the task is to be assigned');
            setShowAlertDialog(true);
            return;
        }

        if (!selectedType) {
            setAlertMessage('Select a type.');
            setShowAlertDialog(true);
            return;
        }

        if (!selectedOutcome) {
            setAlertMessage('Select Call Outcome.');
            setShowAlertDialog(true);
            return;
        }

        setLoading(true);
        console.log('Saving HTML:', description);

        try {
            const payload = {
                SchoolCode: schoolCode || '',
                FamilyCode: familyCode || '',
                Login: login || '',
                L: lParam || 'System',
                discussion: description || '',
                ToLogin: selectedTo || '',
                actionDate: actionDate || '',
                problemType: selectedType || '',
                callOutcome: selectedOutcome || '',
                reason: selectedReason || '',
                timeSpent: timeSpent || '',
                Fixed: isFixed ? '1' : '0',
                attachments: attachments
            };

            const response = await fetch(`${API_BASE_URL}api/save_support_task/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || 'Failed to save task');
            }

            setDescription('');
            setSelectedTo('');
            setIsFixed(false);
            setSelectedType('');
            setReasonOptions([]);
            setSelectedOutcome('');
            setTimeSpent('');
            setAttachments([]);
            attachmentSessionRef.current += 1;
            fetchData();

        } catch (error: any) {
            console.error("Save Error:", error);
            setAlertMessage(`Error saving task: ${error.message}`);
            setShowAlertDialog(true);
        } finally {
            setLoading(false);
        }
    };

    const handleSetWork = (actionType: string) => {
        if (!selectedStudent || selectedStudent === '-Select-') {
            setAlertMessage(`Please select a student to ${actionType === '1' ? 'Set' : 'View'} Work.`);
            setShowAlertDialog(true);
            return;
        }

        const studentObj = students.find((s: any) => s.id === selectedStudent);
        const gradeYear = studentObj ? studentObj.grade : '';
        const currentPath = location.pathname + location.search;

        const targetPath = actionType === '1'
            ? '/SCHOOL/Teacher/EL_SetWork'
            : '/SCHOOL/Teacher/EL_ViewWork';
        const queryParams = new URLSearchParams();
        queryParams.set('SchoolCode', searchParams.get('SchoolCode') || '');
        queryParams.set('Work2FamilyCode', login);
        queryParams.set('Work2Login', selectedStudent);
        queryParams.set('GradeYear', gradeYear);

        navigate({
            pathname: targetPath,
            search: `?${queryParams.toString()}`
        }, {
            state: {
                returnPath: currentPath
            }
        });
    };

    const handleAssignMDClick = () => {
        if (!selectedStudent || selectedStudent === '-Select-') {
            setAlertMessage(`Please select a student to assign Maths Doctor`);
            setShowAlertDialog(true);
            return;
        }
        setShowMDTimeConfirm(true);
    };
    const handleAssignECClick = () => {
        if (!selectedStudent || selectedStudent === '-Select-') {
            setAlertMessage(`Please select a student to assign English Check`);
            setShowAlertDialog(true);
            return;
        }
        setShowECTimeConfirm(true);
    };

    const proceedWithAssignMD = async (mode: 'NOW' | 'LATER') => {
        setShowMDTimeConfirm(false);
        setIsNowHovered(false);
        setIsLaterHovered(false);

        const studentObj = data?.students?.find((s: Student) => s.id === selectedStudent);
        const studyYear = studentObj ? studentObj.grade : '0';

        const compositeLogin = `${selectedStudent}^${studyYear}`;

        if (mode === 'NOW') {
            setLoading(true);

            try {
                const now = new Date();
                const formattedDate = now.toISOString().split('T')[0];

                const payload = {
                    school_code: schoolCode,
                    family_code: login,
                    login: compositeLogin,
                    set_date: formattedDate,
                    teacher_login: lParam
                };

                const response = await fetch(`${API_BASE_URL}api/assign_maths_doctor/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });

                const result = await response.json();

                if (result.status === 'success') {
                    setAlertMessage("Maths Doctor assigned successfully.");
                    setShowAlertDialog(true);
                } else {
                    setAlertMessage(result.message || "Failed to assign Maths Doctor immediately.");
                    setShowAlertDialog(true);
                }

            } catch (error) {
                console.error("Error assigning MD", error);
                setAlertMessage("Failed to assign Maths Doctor immediately.");
                setShowAlertDialog(true);
            } finally {
                setLoading(false);
            }

        } else {
            const width = window.innerWidth - 100;
            const height = window.innerHeight - 100;
            const left = (window.screen.width / 2) - (width / 2);
            const top = (window.screen.height / 2) - (height / 2);

            const url = `/SUPPORT/AssignMD?SchoolCode=${encodeURIComponent(schoolCode)}&FamilyCode=${encodeURIComponent(login)}&Login=${encodeURIComponent(compositeLogin)}&TeacherLogin=${encodeURIComponent(lParam)}`;

            openBlockedWindow(
                url,
                "AssignMD",
                `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=yes`
            );
        }
    };
    const proceedWithAssignEC = async (mode: 'NOW' | 'LATER') => {
        setShowECTimeConfirm(false);
        setIsNowHovered(false);
        setIsLaterHovered(false);

        const studentObj = data?.students?.find((s: Student) => s.id === selectedStudent);
        const studyYear = studentObj ? studentObj.grade : '0';

        const compositeLogin = `${selectedStudent}^${studyYear}`;

        if (mode === 'NOW') {
            setLoading(true);

            try {
                const now = new Date();
                const formattedDate = now.toISOString().split('T')[0];

                const payload = {
                    school_code: schoolCode,
                    family_code: login,
                    login: compositeLogin,
                    set_date: formattedDate,
                    teacher_login: lParam
                };

                const response = await fetch(`${API_BASE_URL}api/assign_english_check/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });

                const result = await response.json();

                if (result.status === 'success') {
                    setAlertMessage("English Check assigned successfully.");
                    setShowAlertDialog(true);
                } else {
                    setAlertMessage(result.message || "Failed to assign English Check immediately.");
                    setShowAlertDialog(true);
                }

            } catch (error) {
                console.error("Error assigning EC", error);
                setAlertMessage("Failed to assign English Check immediately.");
                setShowAlertDialog(true);
            } finally {
                setLoading(false);
            }

        } else {
            const width = window.innerWidth - 100;
            const height = window.innerHeight - 100;
            const left = (window.screen.width / 2) - (width / 2);
            const top = (window.screen.height / 2) - (height / 2);

            const url = `/SUPPORT/AssignEC?SchoolCode=${encodeURIComponent(schoolCode)}&FamilyCode=${encodeURIComponent(login)}&Login=${encodeURIComponent(compositeLogin)}&TeacherLogin=${encodeURIComponent(lParam)}`;

            openBlockedWindow(
                url,
                "AssignEC",
                `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=yes`
            );
        }
    };

    const handleNotifyToggle = async (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!data) return;
        const newVal = e.target.checked;

        setData((prev) => prev ? ({
            ...prev,
            customer: { ...prev.customer, notifyOnUsage: newVal }
        }) : null);

        try {
            const response = await fetch(`${API_BASE_URL}api/toggle_notification`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    SchoolCode: schoolCode,
                    FamilyCode: familyCode,
                    Login: login,
                    Notify: newVal
                })
            });

            if (!response.ok) throw new Error("Failed to update");

        } catch (err) {
            console.error("Toggle Error:", err);
            setData((prev) => prev ? ({
                ...prev,
                customer: { ...prev.customer, notifyOnUsage: !newVal }
            }) : null);
            setAlertMessage("Failed to update notification setting.");
            setShowAlertDialog(true);
        }
    };

    const handleOpenEmails = () => {
        const url = `/SUPPORT/EL_MailsSent?C=${schoolCode}&F=${login}`;
        window.open(url, 'MailsSent', 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,copyhistory=no,width=2250,height=900,top=50,left=50');
    };

    const handleSendEmail = async () => {
        if (!selectedEmailSubject || !schoolCode || !login) {
            setAlertMessage("Missing required data to send email.");
            setShowAlertDialog(true);
            return;
        }

        setLoading(true);
        setShowEmailConfirmDialog(false);
        if (selectedEmailSubject === 'Reset Password') {
            try {
                const response = await fetch(`${API_BASE_URL}api/send_reset_password_email/`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ SchoolCode: schoolCode, FamilyCode: login, L: lParam }),
                });
                const result = await response.json();
                setAlertMessage(response.ok && result.success ? 'Email sent successfully.'
                    : `Failed to send email: ${result.error || 'Unknown error'}`);
            } catch (error: any) {
                setAlertMessage(`Error: ${error.message}`);
            } finally {
                setShowAlertDialog(true);
                setLoading(false);
                setSelectedEmailSubject(null);
            }
            return;
        }

        try {
            // Extract country from schoolCode (e.g., "ELW_AU" -> "AU")
            const country = schoolCode.split('_').pop() || 'AU';

            // Map subject to the original values (0, 1, 2)
            const subjectMap: Record<string, string> = {
                'Maths and English': '0',
                'Maths Only': '1',
                'English Only': '2',
            };
            const subject = subjectMap[selectedEmailSubject] || '0';

            const payload = {
                SchoolCode: schoolCode,
                FamilyCode: login,
                Login: selectedStudent || login,
                Subject: subject,
                Country: country,
            };

            const response = await fetch(`${API_BASE_URL}api/send_instant_email/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            const result = await response.json();
            if (response.ok) {
                setAlertMessage("Email sent successfully.");
                setShowAlertDialog(true);
            } else {
                setAlertMessage(`Failed to send email: ${result.error || 'Unknown error'}`);
                setShowAlertDialog(true);
            }
        } catch (error: any) {
            setAlertMessage(`Error: ${error.message}`);
            setShowAlertDialog(true);
        } finally {
            setLoading(false);
            setSelectedEmailSubject(null);
        }
    };

    const submitWhiteboardLink = async () => {
        setShareConfirmation(null);
        try {
            const response = await fetch(`${API_BASE_URL}api/support/share-whiteboard-link/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    SchoolCode: schoolCode,
                    FamilyCode: sessionStorage.getItem('AddEditLogin') || '',
                    Login: selectedStudent,
                    WhiteBoardLink: whiteboardLink.trim()
                })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.error || 'Unable to share the link.');
            setAlertMessage(result.message || 'Link Shared Successfully.');
        } catch (error) {
            console.error('Share Link Error:', error);
            setAlertMessage(error instanceof Error ? error.message : 'Unable to share the link.');
        }
        setShowAlertDialog(true);
    };

    const openCurrentScreen = async () => {
        setShareConfirmation(null);
        try {
            const familyCodeForShare = sessionStorage.getItem('AddEditLogin') || '';
            const questionLookupParams = new URLSearchParams({
                SchoolCode: schoolCode,
                FamilyCode: familyCodeForShare,
                Login: selectedStudent,
                Answered: currentScreenAnswered ? '1' : '0'
            });
            let result: any;
            setLoading(true);
            try {
                const questionResponse = await fetch(
                    `${API_BASE_URL}api/support/current-screen-question/?${questionLookupParams.toString()}`
                );
                result = await questionResponse.json();
                if (!questionResponse.ok) {
                    throw new Error(result.error || 'Unable to load the current screen question.');
                }
            } finally {
                setLoading(false);
            }
            const lessonFolder = result.lsnTestCode.endsWith('_E')
                ? result.lsnTestCode
                : `${result.lsnTestCode}_E`;
            const params = new URLSearchParams({
                SchoolCode: schoolCode,
                FamilyCode: familyCodeForShare,
                Login: selectedStudent,
                LsnTestCode: lessonFolder,
                folder: lessonFolder,
                name: lessonFolder.replace(/_E$/, ''),
                diccode: result.dicCode || lessonFolder,
                EQCountry: getCountryFromSchoolCode(schoolCode),
                DBWrite: 'False',
                ReturnToTutorial: 'False',
                CalledFrom: window.location.href,
                ViewLesson: 'Y',
                CloseOnBackOrOk: 'Y',
                QnNo: result.qnNo
            });
            const response = await fetch(`${API_BASE_URL}api/generate-sso-url/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    login: selectedStudent,
                    schoolcode: schoolCode,
                    familycode: familyCodeForShare,
                    page: 'Question',
                    lessoncode: result.lsnTestCode,
                    questionno: result.qnNo,
                    eqcountry: getCountryFromSchoolCode(schoolCode),
                    params: params.toString()
                })
            });
            const ssoResult = await response.json();
            if (!response.ok || !ssoResult.success || !ssoResult.url) {
                throw new Error(ssoResult.error || 'Unable to open the student question.');
            }

            window.location.assign(ssoResult.url);
        } catch (error) {
            console.error('Current Screen Error:', error);
            setAlertMessage(error instanceof Error ? error.message : 'Unable to load the current screen.');
            setShowAlertDialog(true);
        }
    };

    const handleMenuOptionClick = (option: string) => {
        setActivePopup(null);

        if (option === 'Share Link') {
            if (!whiteboardLink.trim()) {
                setAlertMessage('Please Enter the Link in Editor window');
                setShowAlertDialog(true);
                return;
            }
            setShareConfirmation('link');
            return;
        }

        if (option === 'Current Screen') {
            setCurrentScreenAnswered(true);
            setShareConfirmation('currentScreen');
            return;
        }
        if (option === 'Maths and English' || option === 'Maths Only' || option === 'English Only' || option === 'Reset Password') {
            setSelectedEmailSubject(option);
            // setAlertMessage(`Do you want to send a mail for ${option}?`);
            setAlertMessage(`Do you want to send a mail`);
            setShowEmailConfirmDialog(true);
            return;
        }
        if (option === 'Add Points') {
            if (!selectedStudent || selectedStudent === '-Select-' || selectedStudent === "0") {
                setAlertMessage("Please Select Student..");
                setShowAlertDialog(true);
                return;
            }
            const width = 450;
            const height = 300;
            const left = (window.screen.width / 2) - (width / 2);
            const top = (window.screen.height / 2) - (height / 2);

            const url = `/Support/EL_AddPoints?C=${encodeURIComponent(schoolCode)}&F=${encodeURIComponent(login)}&L=${encodeURIComponent(selectedStudent)}`;
            openBlockedWindow(url, 'AddPoints', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`);
        }

        if (option === 'View Points') {
            if (!selectedStudent || selectedStudent === '-Select-' || selectedStudent === "0") {
                setAlertMessage("Please Select Student..");
                setShowAlertDialog(true);
                return;
            }

            const url = `/Support/EL_ViewPoints?C=${encodeURIComponent(schoolCode)}&F=${encodeURIComponent(login)}&L=${encodeURIComponent(selectedStudent)}`;

            const width = window.innerWidth - 10;
            const height = window.innerHeight - 10;
            const left = (window.screen.width / 2) - (width / 2);
            const top = (window.screen.height / 2) - (height / 2);

            openBlockedWindow(url, 'ViewPoints', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`);
        }

        if (option === 'Create Default LessonPlan - Maths' || option === 'Create Default LessonPlan - English') {
            const studentObj = students.find((s: any) => s.id === selectedStudent);
            const gradeYear = studentObj ? studentObj.grade : '0';
            const subject = option.includes('Maths') ? 'Mathematics' : 'English';

            let countryName = 'Australia';
            if (schoolCode) {
                const parts = schoolCode.split('_');
                const suffix = parts[parts.length - 1].toUpperCase();
                if (suffix === 'AU') countryName = 'Australia';
                else if (suffix === 'UK') countryName = 'United Kingdom';
                else if (suffix === 'US') countryName = 'USA';
                else if (suffix === 'CA') countryName = 'Canada';
                else if (suffix === 'NZ') countryName = 'New Zealand';
                else if (suffix === 'IN') countryName = 'India';
                else if (suffix === 'ZA') countryName = 'South Africa';
            }

            const url = `/Support/EL_CreateDefaultLessonPlan?C=${encodeURIComponent(schoolCode)}&F=${encodeURIComponent(login)}&L=${encodeURIComponent(selectedStudent)}&GrdYr=${gradeYear}&Subject=${subject}&KT=${encodeURIComponent(countryName)}`;

            const width = window.innerWidth;
            const height = window.innerHeight;
            const left = (window.screen.width / 2) - (width / 2);
            const top = (window.screen.height / 2) - (height / 2);

            openBlockedWindow(url, 'CreateDefaultLP', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`);
        }

        if (option === 'Create MathsDoctor LessonPlan') {
            if (!selectedStudent || selectedStudent === '-Select-' || selectedStudent === "0") {
                setAlertMessage("Please Select Student..");
                setShowAlertDialog(true);
                return;
            }

            const studentObj = students.find((s: any) => s.id === selectedStudent);
            const gradeYear = studentObj ? studentObj.grade : '0';

            let countryName = 'Australia';
            if (schoolCode) {
                const parts = schoolCode.split('_');
                const suffix = parts[parts.length - 1].toUpperCase();
                if (suffix === 'AU') countryName = 'Australia';
                else if (suffix === 'UK') countryName = 'United Kingdom';
                else if (suffix === 'US') countryName = 'USA';
                else if (suffix === 'CA') countryName = 'Canada';
                else if (suffix === 'NZ') countryName = 'New Zealand';
                else if (suffix === 'IN') countryName = 'India';
                else if (suffix === 'ZA') countryName = 'South Africa';
            }

            const url = `/SYSADMIN/MathsDoctor/CreateMathsDoctorLessonPlan?C=${encodeURIComponent(schoolCode)}&F=${encodeURIComponent(login)}&L=${encodeURIComponent(selectedStudent)}&GrdYr=${gradeYear}&KT=${encodeURIComponent(countryName)}`;

            const width = window.innerWidth;
            const height = window.innerHeight;
            const left = (window.screen.width - width) / 2;
            const top = (window.screen.height - height) / 2;

            openBlockedWindow(url, 'CreateMathsDoctorLessonPlan', `width=${width},height=${height},top=${top},left=${left},scrollbars=yes,resizable=yes`);
        }


        if (option === 'Create EnglishCheck LessonPlan') {
            if (!selectedStudent || selectedStudent === '-Select-' || selectedStudent === "0") {
                setAlertMessage("Please Select Student..");
                setShowAlertDialog(true);
                return;
            }

            const studentObj = students.find((s: any) => s.id === selectedStudent);
            const gradeYear = studentObj ? studentObj.grade : '0';

            let countryName = 'Australia';
            if (schoolCode) {
                const parts = schoolCode.split('_');
                const suffix = parts[parts.length - 1].toUpperCase();
                if (suffix === 'AU') countryName = 'Australia';
                else if (suffix === 'UK') countryName = 'United Kingdom';
                else if (suffix === 'US') countryName = 'USA';
                else if (suffix === 'CA') countryName = 'Canada';
                else if (suffix === 'NZ') countryName = 'New Zealand';
                else if (suffix === 'IN') countryName = 'India';
                else if (suffix === 'ZA') countryName = 'South Africa';
            }

            const url = `/SYSADMIN/EnglishCheck/CreateEnglishCheckLessonPlan?C=${encodeURIComponent(schoolCode)}&F=${encodeURIComponent(login)}&L=${encodeURIComponent(selectedStudent)}&GrdYr=${gradeYear}&KT=${encodeURIComponent(countryName)}`;

            const width = window.innerWidth;
            const height = window.innerHeight;
            const left = (window.screen.width - width) / 2;
            const top = (window.screen.height - height) / 2;

            openBlockedWindow(url, 'CreateMathsDoctorLessonPlan', `width=${width},height=${height},top=${top},left=${left},scrollbars=yes,resizable=yes`);
        }
        if (option === 'User Diary') {
            if (!selectedStudent || selectedStudent === '-Select-' || selectedStudent === "0") {
                setAlertMessage("Please Select Student.");
                setShowAlertDialog(true);
                return;
            }

            const width = window.innerWidth - 10;
            const height = window.innerHeight - 135;
            const left = (window.screen.width / 2) - (width / 2);
            const top = (window.screen.height / 2) - (height / 2);

            const studentIndex = students.findIndex((s: any) => s.id === selectedStudent);
            let cname = 0;

            if (students.length > 1) {
                cname = studentIndex + 1;
            } else {
                cname = studentIndex;
            }

            const url = `/STUDENT/Reports/EL_UserDiary?CalledFrom=Support&SchoolCode=${encodeURIComponent(schoolCode)}&FamilyCode=${encodeURIComponent(login)}&Login=A&cname=${cname}`;

            // Opened directly (no overlay/lock on this page)
            window.open(url, 'UserDiary', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`);
        }
        if (option === 'Parent/Teacher Report') {
            if (!selectedStudent || selectedStudent === '-Select-' || selectedStudent === "0") {
                setAlertMessage("Please Select Student.");
                setShowAlertDialog(true);
                return;
            }

            const width = window.innerWidth;
            const height = window.innerHeight;
            const left = (window.screen.width / 2) - (width / 2);
            const top = (window.screen.height / 2) - (height / 2);

            const studentIndex = students.findIndex((s: any) => s.id === selectedStudent);
            let cname = 0;

            if (students.length > 1) {
                cname = studentIndex + 1;
            } else {
                cname = studentIndex;
            }

            const url = `/STUDENT/Reports/EL_PTReport?CalledFrom=Support&SchoolCode=${encodeURIComponent(schoolCode)}&FamilyCode=${encodeURIComponent(login)}&Login=A&cname=${cname}`;

            // Opened directly (no overlay/lock on this page)
            window.open(url, 'PTReport', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`);
        }
        if (option === 'Login Usage') {
            // if (!selectedStudent || selectedStudent === '-Select-' || selectedStudent === "0") {
            //     setAlertMessage("Please Select Student.");
            //     setShowAlertDialog(true);
            //     return;
            // }

            const studentObj = students.find((s: any) => s.id === selectedStudent);
            const studentName = studentObj ? studentObj.firstName : '';

            const url = `/WebAdmin/Reports/EL_LoginUsage?CalledFrom=Support&SchoolCode=${encodeURIComponent(schoolCode)}&FamilyCode=${encodeURIComponent(login)}&Login=${encodeURIComponent(selectedStudent)}&Lname=${encodeURIComponent(studentName)}`;

            const width = window.screen.availWidth - 100;
            const height = window.screen.availHeight - 100;

            const left = (window.screen.availWidth - width) / 2;
            const top = (window.screen.availHeight - height) / 2;

            openBlockedWindow(url, 'LoginUsage', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`);
        }

        if (option === 'View Lesson Plan - Maths' || option === 'View Lesson Plan - English') {
            if (!selectedStudent || selectedStudent === '-Select-' || selectedStudent === "0") {
                setAlertMessage("Please Select Student..");
                setShowAlertDialog(true);
                return;
            }

            const subject = option.includes('Maths') ? 'Mathematics' : 'English';

            const width = window.screen.availWidth - 50;
            const height = window.screen.availHeight - 150;
            const left = (window.screen.width / 2) - (width / 2);
            const top = (window.screen.height / 2) - (height / 2);

            const url = `/SUPPORT/EL_ViewLessonPlan?SchoolCode=${encodeURIComponent(schoolCode)}&FamilyCode=${encodeURIComponent(login)}&Login=${encodeURIComponent(selectedStudent)}&Subject=${subject}`;

            openBlockedWindow(url, 'ViewLessonPlan', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`);
        }

        if (option === 'Student Study History') {
            if (
                !selectedStudent ||
                selectedStudent === '-Select-' ||
                selectedStudent === '0'
            ) {
                setAlertMessage("Please Select Student.");
                setShowAlertDialog(true);
                return;
            }

            const url = `/Support/EL_StudentStudyHistory?S=${encodeURIComponent(schoolCode)}&F=${encodeURIComponent(login)}&L=${encodeURIComponent(selectedStudent)}`;

            const newWindow = window.open(
                url,
                'StudentStudyHistory',
                'width=1200,height=800,resizable=yes,scrollbars=yes'
            );

            if (newWindow) {
                newWindow.moveTo(0, 0);
                newWindow.resizeTo(
                    window.screen.availWidth,
                    window.screen.availHeight
                );
            }
        }

        if (option === 'Student Performance Report') {
            if (!selectedStudent || selectedStudent === '-Select-' || selectedStudent === "0") {
                setAlertMessage("Please Select Student.");
                setShowAlertDialog(true);
                return;
            }
            navigate(`/Support/EL_StudentPerformanceReport?S=${encodeURIComponent(schoolCode)}&F=${encodeURIComponent(login)}&L=${encodeURIComponent(selectedStudent)}`);

            const url = `/Support/EL_StudentPerformanceReport?S=${encodeURIComponent(schoolCode)}&F=${encodeURIComponent(login)}&L=${encodeURIComponent(selectedStudent)}&Fname=${encodeURIComponent(students.find((s: any) => s.id === selectedStudent)?.firstName || '')}&Country=${encodeURIComponent(schoolCode ? schoolCode.split('_').slice(-1)[0] : 'AU')}`;

            const width = window.screen.availWidth - 100;
            const height = window.screen.availHeight - 100;

            const left = (window.screen.availWidth - width) / 2;
            const top = (window.screen.availHeight - height) / 2;

            // openBlockedWindow(url, 'StudentPerformanceReport', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`);
        }



        if (option === 'MD Analysis Report') {
            if (!selectedStudent || selectedStudent === '-Select-' || selectedStudent === "0") {
                setAlertMessage("Please Select Student.");
                setShowAlertDialog(true);
                return;
            }
            navigate(`/Support/EL_MDAnalysisreport?S=${encodeURIComponent(schoolCode)}&F=${encodeURIComponent(login)}&L=${encodeURIComponent(selectedStudent)}`);

            const url = `/Support/EL_MDAnalysisreport?S=${encodeURIComponent(schoolCode)}&F=${encodeURIComponent(login)}&L=${encodeURIComponent(selectedStudent)}&Fname=${encodeURIComponent(students.find((s: any) => s.id === selectedStudent)?.firstName || '')}&Country=${encodeURIComponent(schoolCode ? schoolCode.split('_').slice(-1)[0] : 'AU')}`;

            const width = window.screen.availWidth - 100;
            const height = window.screen.availHeight - 100;

            const left = (window.screen.availWidth - width) / 2;
            const top = (window.screen.availHeight - height) / 2;

            // openBlockedWindow(url, 'StudentPerformanceReport', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`);
        }


        if (option === 'Edit Login Details') {
            const url = `/SYSADMIN/EditLogin?SchoolCode=${encodeURIComponent(schoolCode)}&FamilyCode=A&Login=${encodeURIComponent(login)}`;

            window.open(url, '_blank');
        }

        if (option === 'ResetMD') {
            if (!selectedStudent || selectedStudent === '-Select-' || selectedStudent === "0") {
                setAlertMessage("Please Select Student.");
                setShowAlertDialog(true);
                return;
            }

            const url = `/SYSADMIN/MathsDoctor/ResetMD?SchoolCode=${encodeURIComponent(schoolCode)}&FamilyCode=${encodeURIComponent(login)}&Login=${encodeURIComponent(selectedStudent)}`;

            const width = window.screen.availWidth - 100;
            const height = window.screen.availHeight - 100;

            const left = (window.screen.availWidth - width) / 2;
            const top = (window.screen.availHeight - height) / 2;

            openBlockedWindow(url, 'ResetMD', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`);
        }
        if (option === 'ResetEC') {
            if (!selectedStudent || selectedStudent === '-Select-' || selectedStudent === "0") {
                setAlertMessage("Please Select Student.");
                setShowAlertDialog(true);
                return;
            }

            const url = `/SYSADMIN/EnglishCheck/ResetEC?SchoolCode=${encodeURIComponent(schoolCode)}&FamilyCode=${encodeURIComponent(login)}&Login=${encodeURIComponent(selectedStudent)}`;

            const width = window.screen.availWidth - 100;
            const height = window.screen.availHeight - 100;

            const left = (window.screen.availWidth - width) / 2;
            const top = (window.screen.availHeight - height) / 2;

            openBlockedWindow(url, 'ResetEC', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`);
        }
    };

    const getStudentStyle = (student: Student) => {
        const gender = student.gender?.trim().toUpperCase();
        const name = student.firstName?.trim().toUpperCase();

        let color = "black";

        if (gender === "M" || gender === "B") {
            color = "blue";
        } else if (gender === "F" || gender === "G") {
            color = "red";
        }

        if (["GUEST", "PARENT", "PARENTS"].includes(name || "")) {
            color = "teal";
        }

        return {
            color,
            cursor: "pointer",
            fontWeight: "bold",
            textDecoration: "underline",
        };
    };

    // Derive country from schoolCode
    const getCountryFromSchoolCode = (sc: string) => {
        const suffix = sc.split('_').pop()?.toUpperCase() || 'AU';
        const map: Record<string, string> = {
            AU: 'Australia', UK: 'United Kingdom', US: 'USA',
            CA: 'Canada', NZ: 'New Zealand', IN: 'India',
            ZA: 'South Africa'
        };
        return map[suffix] || 'Australia';
    };

    const handleLoggedInUserClick = (student: Student) => {
        const url = `/SUPPORT/EL_ShowCurrentActivities?S=${encodeURIComponent(schoolCode)}&F=${encodeURIComponent(login)}&L=${encodeURIComponent(student.id)}`;
        window.open(url, '_blank');
    }


    const isTypeOther = selectedType.toLowerCase().includes('other');

    if (error) return <div style={{ color: 'red', padding: '20px' }}>Error: {error}</div>;
    if (!data) return <div style={{ padding: '20px' }}><Loading /></div>;

    const { customer, students, tasks } = data;
    const staffMembers = data?.dropdowns?.staff_members || [];
    const isDistributorStaffItem = (staff: any) => {
        if (!staff) return false;

        const schoolCode = String(staff.schoolCode || staff.SchoolCode || staff.school_code || '').trim().toUpperCase();
        return schoolCode !== '' && schoolCode !== 'A';
    };

    const regularStaffMembers = staffMembers.filter((staff: any) => !isDistributorStaffItem(staff));
    const distributorStaffMembers = staffMembers.filter(isDistributorStaffItem);

    return (
        <div style={styles.container}>
            {loading && <Loading />}
            <div style={styles.headerRow}>
                <div style={styles.col1}></div>
                <div style={styles.col2}>
                    Family Support
                </div>
                <div style={styles.col3}>
                    <div>
                        Last access on : <span style={{ color: 'red' }}>{customer.lastAccessOn || '-'}</span>
                    </div>
                    <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', fontWeight: 'normal', fontSize: 'smaller' }}>
                        <input
                            type="checkbox"
                            checked={!!customer.notifyOnUsage}
                            onChange={handleNotifyToggle}
                            style={{ marginRight: '5px' }}
                        />
                        Notify on usage
                    </label>
                </div>
                <div style={styles.col4}>
                    {filterType !== 'CustEntryTut' && fromCourtesyCall !== 'Y' && (
                        <a
                            href="/Sysadmin"
                            onClick={() => {
                                sessionStorage.removeItem('EL_ListOfTasks_State');
                                sessionStorage.removeItem('EL_ListOfTasks_Restore');
                            }}
                            style={{
                                color: 'blue',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                                fontFamily: 'Arial'
                            }}
                        >
                            Back To Menu
                        </a>
                    )}
                </div>
            </div>
            <table style={styles.table}>
                <thead>
                    <tr>
                        <th style={styles.th}>Surname</th>
                        <th style={styles.th}>Parents</th>
                        <th style={styles.th}>Address</th>
                        <th style={styles.th}>Suburb</th>
                        <th style={styles.th}>Postcode</th>
                        <th style={styles.th}>State</th>
                        <th style={styles.th}>Phone #</th>
                        <th style={styles.th}>Date of sale</th>
                        <th style={styles.th}>Package(s)</th>
                        <th style={styles.th}>Distributor</th>
                    </tr>
                </thead>
                <tbody>
                    <tr style={{ paddingTop: '150px' }}>
                        <td style={{ ...styles.td, paddingTop: '15px' }}>
                            <a
                                href={`/SALES/SalesModify/EL_SalesModify?SchoolCode=${encodeURIComponent(schoolCode)}&FamilyCode=${encodeURIComponent(familyCode)}&Login=${encodeURIComponent(login)}&Country=${encodeURIComponent(getCountryFromSchoolCode(schoolCode))}&Previous=/SUPPORT/EL_AddEditTask&FilterType=${encodeURIComponent(filterType)}&S=${encodeURIComponent(sParam)}&F=${encodeURIComponent(fParam)}&L=${encodeURIComponent(lParam)}`}
                                style={{ color: "blue" }}
                            >{customer.surname || '-'}</a>
                        </td>
                        <td style={{ ...styles.td, paddingTop: '15px' }}>
                            {customer.parentsName}
                            {customer.paymentDue && <div style={{ color: 'red', fontWeight: 'bold', marginTop: '4px' }}></div>}
                        </td>
                        <td style={{ ...styles.td, paddingTop: '15px' }}>{customer.address}</td>
                        <td style={{ ...styles.td, paddingTop: '15px' }}>{customer.suburb}</td>
                        <td style={{ ...styles.td, paddingTop: '15px' }}>{customer.postcode}</td>
                        <td style={{ ...styles.td, paddingTop: '15px' }}>
                            {customer.state}
                            {customer.localTime && (
                                <div style={{ fontSize: '9pt', color: '#000' }}>
                                    (Local Time: {customer.localTime})
                                </div>
                            )}
                        </td>                        {/* <td style={{ ...styles.td, paddingTop: '15px' }}>{customer.localTime}</td> */}
                        <td style={{ ...styles.td, paddingTop: '15px' }}>{customer.phone}<br />{customer.mobile1}<br />{customer.mobile2}</td>
                        <td style={{ ...styles.td, paddingTop: '15px' }}>{customer.dateOfSale}</td>
                        <td style={{ ...styles.td, paddingTop: '15px' }}>{customer.packages}</td>
                        <td style={{ ...styles.td, paddingTop: '15px' }}>{customer.distributor}</td>
                    </tr>
                </tbody>
            </table>

            <table style={{ ...styles.table, border: 'none' }}>
                <tbody>
                    <tr>
                        <td style={{ ...styles.td, border: 'none', width: '35%' }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                gap: '12px',
                                marginBottom: '5px',
                                backgroundColor: '#E8E8FF',
                                padding: '5px',
                                fontFamily: 'Arial',
                                fontSize: '10pt'
                            }}>
                                <div style={{ fontSize: "11pt", fontWeight: "700" }}><b style={{ fontWeight: "900", fontSize: "11pt" }}>Login:</b> {login}</div>

                                <div>
                                    <b style={{ fontWeight: "900", fontSize: "11pt" }}>Email:</b>{' '}
                                    <a href={`mailto:${customer.email}`} style={{ color: 'blue', textDecoration: 'underline', fontWeight: '900', fontSize: "11pt" }}>
                                        {customer.email}
                                    </a>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                    <b style={{ fontWeight: "900", fontSize: "11pt" }}>Select Student:</b>
                                    <select
                                        id='ddlWorkTo'
                                        className='cssTextBox'
                                        style={{ width: '135px', padding: '1px', fontSize: '9pt', fontFamily: 'Arial' }}
                                        onChange={(e) => setSelectedStudent(e.target.value)}
                                    >
                                        <option value="">-Select-</option>
                                        {students && students.map((stu) => (
                                            <option key={stu.id} value={stu.id}>{stu.firstName}</option>
                                        ))}
                                    </select>
                                </div>

                                <div style={{ fontWeight: 'bold' }}>&</div>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2px' }}>
                                    <button style={styles.actionButton} onClick={(e) => handleSetWork('1')}>Set Work</button>
                                    <button style={styles.actionButton} onClick={handleAssignMDClick}>Assign MD</button>
                                    <button style={styles.actionButton} onClick={handleAssignECClick}>Assign EC</button>
                                    <button
                                        style={styles.actionButton}
                                        onClick={() => handleSetWork('2')}
                                    >
                                        View Work
                                    </button>
                                    <button
                                        style={styles.actionButton}
                                        onClick={handleOpenEmails}
                                    >
                                        eMails
                                    </button>
                                    <button style={styles.actionButton} onClick={(e) => handlePopupClick(e, 'plans')}>WLP / Points</button>
                                    <button style={styles.actionButton} onClick={(e) => handlePopupClickN(e, 'reports')}>Reports</button>
                                    <button style={styles.actionButton} onClick={(e) => handlePopupClick(e, 'admin')}>Admin</button>
                                    <button style={styles.actionButton} onClick={(e) => handlePopupClick(e, 'email')}>Instant eMails</button>
                                    <button
                                        style={styles.actionButton}
                                        onClick={() => {
                                            const width = 1200;
                                            const height = window.screen.availHeight; // full available height

                                            const left = window.screenX + (window.innerWidth - width) / 2;
                                            const top = 0; // start from top

                                            window.open(
                                                `/SUPPORT/AdditionalStudentsInfo?SchoolCode=${schoolCode}&FamilyCode=${familyCode}&S=${schoolCode}&F=${familyCode}&L=${login}`,
                                                "_blank",
                                                `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
                                            );
                                        }}
                                    >
                                        Additional StudentInfo
                                    </button>
                                    <button style={styles.actionButton} onClick={(e) => handlePopupClickN(e, 'Share')}>Share</button>
                                    <input
                                        type="text"
                                        value={whiteboardLink}
                                        onChange={(e) => setWhiteboardLink(e.target.value)}
                                        aria-label="Whiteboard link to share"
                                        style={{ width: '250px', border: '1px solid #5B91B5', fontFamily: 'Arial', fontWeight: 'bold' }}
                                    />
                                </div>
                                <div>
                                    <input type="text" style={{ width: '250px', marginLeft: '115px' }} />&nbsp;
                                    <button style={styles.actionButton} onClick={handleMDStats}>MD Stats</button>
                                </div>

                            </div>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}>
                                <span style={{ fontWeight: 'bold', fontSize: '11pt' }}>Family info:</span>
                                <button style={styles.actionButton}
                                    onClick={() => {
                                        const width = 900;
                                        const height = window.screen.availHeight;
                                        const left = window.screenX + (window.innerWidth - width) / 2;
                                        const top = 0;
                                        //www.elearnoncloud.com/DEALER/EL_EditFamilyProfile.aspx?SchoolCode=DLR_KE_AU&FamilyCode=kedemo
                                        window.open(
                                            `/DEALER/EL_EditFamilyProfile?SchoolCode=${schoolCode}&FamilyCode=${familyCode}&Login=${login}&Prev=/SUPPORT/EL_AddEditTask`,
                                            "_blank",
                                            `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
                                        );
                                    }}>
                                    EDIT
                                </button>
                            </div>

                            <div style={{ border: '2px solid black', padding: '5px', minHeight: '20px', minWidth: '60%', marginTop: '5px' }}>
                                <b>Student Name(s):</b>&nbsp;
                                {students && students.length > 0 ? students.map((stu, idx) => (
                                    <span key={stu.id || idx}>
                                        <span style={getStudentStyle(stu)} onClick={() => handleStudentClick(stu)}>
                                            {stu.firstName}{stu.isSelective ? '^' : ''}
                                        </span>
                                        &nbsp;({stu.grade})
                                        {stu.isLoggedIn && <img src={checkImg} alt="Logged In" style={{ marginLeft: '4px', verticalAlign: 'middle', cursor: 'pointer' }} onClick={() => handleLoggedInUserClick(stu)} />}
                                        {(idx < students.length - 1) && <span style={{ margin: '0 8px' }}> </span>}
                                    </span>
                                )) : <span>No students found</span>}
                                <div style={{ textAlign: 'right', marginTop: '5px' }}>
                                    <button
                                        type="button"
                                        style={styles.actionButton}
                                        onClick={handleNewMSR}
                                        onMouseOver={(e) => {
                                            e.currentTarget.style.color = 'white';
                                        }}
                                        onMouseOut={(e) => {
                                            e.currentTarget.style.color = 'black';
                                        }}
                                    >
                                        New MSR
                                    </button>
                                </div>
                            </div>

                        </td>
                    </tr>
                </tbody>
            </table>

            {activePopup && (
                <div style={{ ...styles.popupMenu, top: popupPos.top, left: popupPos.left }}>

                    {/* {activePopup === 'reports' && ['Parent/Teacher Report', 'User Diary', 'Scores', 'Student Study History', 'Login Usage', 'Student Performance Report'].map(m => ( */}
                    {/* SCORES PAGE NOT DEVELOPED YET, SO COMMENTED OUT THE OPTION */}
                    {activePopup === 'reports' && ['Parent/Teacher Report', 'User Diary', 'Student Study History', 'Login Usage', 'Student Performance Report', 'MD Analysis Report'].map(m => (
                        // {activePopup === 'reports' && ['Parent/Teacher Report', 'User Diary', 'Student Study History', 'Login Usage', 'MD Analysis Report'].map(m => (
                        <div key={m} style={hoveredMenuItem === m ? styles.menuItemHovered : styles.menuItem} onMouseEnter={() => setHoveredMenuItem(m)} onMouseLeave={() => setHoveredMenuItem(null)} onClick={() => handleMenuOptionClick(m)}>{m}</div>
                    ))}




                    {/* {activePopup === 'reports' && [
                        'Parent/Teacher Report',
                        'User Diary',
                        'Scores',
                        'Student Study History',
                        'Login Usage',
                        'Student Performance Report'
                    ].map(m => {
                        const isDisabled = m === 'Student Study History';

                        return (
                            <div
                                key={m}
                                style={{
                                    ...(hoveredMenuItem === m ? styles.menuItemHovered : styles.menuItem),
                                    ...(isDisabled && { color: 'gray', cursor: 'not-allowed' })
                                }}
                                onMouseEnter={() => !isDisabled && setHoveredMenuItem(m)}
                                onMouseLeave={() => setHoveredMenuItem(null)}
                                onClick={() => !isDisabled && handleMenuOptionClick(m)}
                            >
                                {m}
                            </div>
                        );
                    })} */}




                    {activePopup === 'plans' && [
                        'Create MathsDoctor LessonPlan',
                        'Create Default LessonPlan - Maths',
                        'Create EnglishCheck LessonPlan',
                        'Create Default LessonPlan - English',
                        'View Lesson Plan - Maths',
                        'View Lesson Plan - English',
                        'View Points',
                        'Add Points'
                    ].map(m => (
                        <div key={m} style={hoveredMenuItem === m ? styles.menuItemHovered : styles.menuItem} onMouseEnter={() => setHoveredMenuItem(m)} onMouseLeave={() => setHoveredMenuItem(null)} onClick={() => handleMenuOptionClick(m)}>{m}</div>
                    ))}

                    {/* {activePopup === 'email' && (
                        <div style={{ ...styles.popupMenu, top: popupPos.top, left: popupPos.left}} onMouseLeave={handlePopupMouseLeave} onMouseEnter={handlePopupMouseEnter}>
                            {['Maths and English', 'Maths Only', 'English Only'].map((m) => (
                                <div key={m} style={styles.menuItem} onClick={() => handleMenuOptionClick(m)}>
                                    {m}
                                </div>
                            ))}
                        </div>
                    )} */}

                    {/* {activePopup === 'email' && ['Maths and English', 'Maths Only', 'English Only'].map(m => (
                        <div key={m} style={hoveredMenuItem === m ? styles.menuItemHovered : styles.menuItem} onMouseEnter={() => setHoveredMenuItem(m)} onMouseLeave={() => setHoveredMenuItem(null)} onClick={() => handleMenuOptionClick(m)}>{m}</div>
                    ))} */}

                    {activePopup === 'email' && [
                        'Maths and English', 'Maths Only', 'English Only',
                        ...(data?.canResetPassword ? ['Reset Password'] : [])
                    ].map(m => (
                        <div key={m} style={hoveredMenuItem === m ? styles.menuItemHovered : styles.menuItem}
                            onMouseEnter={() => setHoveredMenuItem(m)} onMouseLeave={() => setHoveredMenuItem(null)}
                            onClick={() => handleMenuOptionClick(m)}>{m}</div>
                    ))}


                    {activePopup === 'admin' && ['ResetMD', 'ResetEC', 'Edit Login Details'].map(m => (
                        <div key={m} style={hoveredMenuItem === m ? styles.menuItemHovered : styles.menuItem} onMouseEnter={() => setHoveredMenuItem(m)} onMouseLeave={() => setHoveredMenuItem(null)} onClick={() => handleMenuOptionClick(m)}>{m}</div>
                    ))}


                </div>
            )}

            {activePopup === 'Share' && (
                <div style={{ ...styles.popupMenu, top: popupPos.top, left: popupPos.left, width: '105px' }} >
                    {activePopup === 'Share' && [
                        'Share Link',
                        'Current Screen'
                    ].map(m => (
                        <div key={m} style={hoveredMenuItem === m ? styles.menuItemHovered : styles.menuItem} onMouseEnter={() => setHoveredMenuItem(m)} onMouseLeave={() => setHoveredMenuItem(null)} onClick={() => handleMenuOptionClick(m)}>{m}</div>
                    ))}
                </div>
            )}

            <div style={{ border: '1px solid blue', padding: '5px', backgroundColor: '#E8E8FF', flex: 1, overflowY: 'auto', minHeight: 0 }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ marginBottom: '10px' }}>
                            <th style={{ ...styles.blueHeader, width: '35%', backgroundColor: 'transparent', borderRight: 'none' }}>Add a Support</th>
                            <th style={{ ...styles.blueHeader, width: '7%', backgroundColor: 'transparent', borderRight: 'none', borderLeft: 'none' }}>From</th>
                            <th style={{ ...styles.blueHeader, width: '10%', backgroundColor: 'transparent', borderRight: 'none', borderLeft: 'none' }}>To</th>
                            <th style={{ ...styles.blueHeader, width: '9%', backgroundColor: 'transparent', borderRight: 'none', borderLeft: 'none' }}>Action Date</th>
                            {/* <th style={{ ...styles.blueHeader, width: '5%', backgroundColor: 'transparent', borderRight: 'none', borderLeft: 'none' }}>Fixed</th> */}
                            {/* CHANGED FIXED TO EMPTY - 03/09/2026 */}
                            <th style={{ ...styles.blueHeader, width: '5%', backgroundColor: 'transparent', borderRight: 'none', borderLeft: 'none' }}></th>
                            <th style={{ ...styles.blueHeader, width: '12%', backgroundColor: 'transparent', borderRight: 'none', borderLeft: 'none' }}>
                                Type
                                <br />
                                (Reasons Type)
                                <br />
                                (Call OutCome)
                            </th>
                            <th style={{ ...styles.blueHeader, width: '8%', backgroundColor: 'transparent', borderRight: 'none', borderLeft: 'none' }}>Time Spent</th>
                            <th style={{ ...styles.blueHeader, width: '2%', backgroundColor: 'transparent', border: '1px solid #FF0000' }}>Att.</th>
                            <th style={{ ...styles.blueHeader, width: '5%', backgroundColor: 'transparent', border: 'none' }}></th>
                        </tr>

                        <tr>
                            <td style={{ padding: '2px', verticalAlign: 'top', paddingTop: '10px' }}>
                                <style>{customQuillStyles}</style>

                                <ReactQuill
                                    ref={quillRef}
                                    theme="snow"
                                    value={description}
                                    onChange={setDescription}
                                    onFocus={() => {
                                        const quill = quillRef.current?.getEditor();
                                        if (quill && quill.getLength() <= 1) {
                                            quill.format('color', '#000000');
                                            quill.format('size', 1);
                                        }
                                    }}
                                    modules={editorModules}
                                    formats={[
                                        'font', 'size',
                                        'bold', 'italic', 'underline',
                                        'color', 'background',
                                        'align',
                                        'list'
                                    ]}
                                />
                            </td>

                            <td style={{ padding: '2px', paddingTop: '10px', verticalAlign: 'middle', textAlign: 'left', color: 'maroon', fontWeight: 'bold' }}>
                                {lParam || 'System'}
                            </td>

                            <td style={{ padding: '2px', paddingTop: '10px', verticalAlign: 'middle' }}>
                                <select
                                    className="cssDropDown"
                                    value={selectedTo}
                                    onChange={(e) => setSelectedTo(e.target.value)}
                                    style={{ width: '80%' }}
                                >
                                    <option value="">Select</option>
                                    {regularStaffMembers.map((staff: any) => (
                                        <option key={`reg-${staff.value}`} value={staff.value}>{staff.label}</option>
                                    ))}
                                    {distributorStaffMembers.length > 0 && (
                                        <optgroup label="----------Distributor Staff--------">
                                            {distributorStaffMembers.map((staff: any) => (
                                                <option key={`dist-${staff.value}`} value={staff.value}>{staff.label}</option>
                                            ))}
                                        </optgroup>
                                    )}
                                </select>
                            </td>

                            <td style={{ padding: '2px', paddingTop: '10px', verticalAlign: 'middle' }}>
                                <input
                                    type="date"
                                    className="cssTextBox"
                                    value={actionDate}
                                    onChange={(e) => setActionDate(e.target.value)}
                                    style={{ width: '80%' }}
                                />
                            </td>

                            <td style={{ padding: '2px 0 0 12px', paddingTop: '10px', verticalAlign: 'middle', textAlign: 'left' }}>
                                <input
                                    type="checkbox"
                                    checked={isFixed}
                                    onChange={(e) => setIsFixed(e.target.checked)}
                                />
                            </td>

                            <td style={{ padding: '2px', paddingTop: '10px', verticalAlign: 'middle', width: '140px' }}>
                                <div style={{ marginBottom: '5px' }}>
                                    <select className="cssDropDown" value={selectedType} onChange={handleTypeChange} style={{ width: '140px' }}>
                                        <option value="">Select Type</option>
                                        {typeMapping.map((item, index) => (
                                            <option key={index} value={item.type}>{item.typeName}</option>
                                        ))}
                                    </select>
                                </div>
                                <div style={{ marginBottom: '5px' }}>
                                    <select className="cssDropDown" value={selectedReason} onChange={(e) => setSelectedReason(e.target.value)} style={{ width: '140px' }} disabled={reasonOptions.length === 0}>
                                        <option value="">Select Reason</option>
                                        {reasonOptions.map((r, i) => <option key={i} value={r}>{r}</option>)}
                                    </select>
                                </div>
                                <div>
                                    <select className="cssDropDown" value={selectedOutcome} onChange={(e) => setSelectedOutcome(e.target.value)} style={{ width: '140px' }}>
                                        <option value="">Select Call Outcome</option>
                                        {data?.dropdowns?.call_outcomes?.map((o, i) => <option key={i} value={o}>{o}</option>)}
                                    </select>
                                </div>
                            </td>

                            <td style={{ padding: '2px', paddingTop: '10px', verticalAlign: 'middle' }}>
                                <select
                                    className="cssDropDown"
                                    value={timeSpent}
                                    onChange={(e) => setTimeSpent(e.target.value)}
                                    style={{ width: '80px' }}
                                >
                                    {/* <option value="">Select</option> */}
                                    {Array.from({ length: 60 }, (_, i) => i + 1).map((minute) => (
                                        <option key={minute} value={minute}>
                                            {minute}m
                                        </option>
                                    ))}
                                </select>
                            </td>

                            <td style={{ padding: '2px', paddingTop: '10px', verticalAlign: 'middle', textAlign: 'left' }}>
                                <img
                                    src={btnAttachment}
                                    alt="Attach"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        const safeAttachments = Array.isArray(attachments) ? attachments : [];
                                        const docNames = safeAttachments.map(a => a.docName).join('|');
                                        const fileNames = safeAttachments.map(a => a.fileName).join('|');

                                        const queryParams = new URLSearchParams({
                                            FileName: docNames,
                                            DocumentName: fileNames,
                                            FromPage: 'Support',
                                            SchoolCode: schoolCode,
                                            FamilyCode: familyCode,
                                            Login: login,
                                            AttachmentSession: String(attachmentSessionRef.current)
                                        });

                                        const url = `${window.location.origin}/SUPPORT/EL_AttachFileSupport?${queryParams.toString()}`;
                                        openPopup(url, 'Attachments', 600, 400);
                                    }}
                                />
                                {attachments.length > 0 && <span style={{ color: 'green', fontWeight: 'bold' }}> ({attachments.length})</span>}
                            </td>

                            {/* 9. Save Button */}
                            <td style={{ padding: '2px', paddingTop: '10px', verticalAlign: 'middle', textAlign: 'left' }}>
                                <button style={styles.actionButton} onClick={handleSaveTask}>Save</button>
                            </td>
                        </tr>
                    </thead>
                </table>
                <div style={{ marginTop: '10px', borderTop: '1px solid blue' }}>
                    <HistoryList
                        tasks={tasks}
                        onStatusChange={handleStatusChange}
                        onOpenAttachments={(task) => {
                            const queryParams = new URLSearchParams({
                                FileName: task.attachments.map(a => a.docName).join('|'),
                                DocumentName: task.attachments.map(a => a.fileName).join('|'),
                                DocumentUrl: task.attachments.map(a => a.url || '').join('|'),
                                FromPage: 'Support',
                                DocOpenOnly: 'Y'
                            });
                            openPopup(
                                `${window.location.origin}/SUPPORT/EL_AttachFileSupport?${queryParams.toString()}`,
                                'Attachments',
                                600,
                                400
                            );
                        }}
                    />
                </div>
            </div>
            {filterType !== 'CustEntryTut' && (
                <div style={{ textAlign: 'center', padding: '5px', flexShrink: 0 }}>
                    <button
                        style={{ ...styles.actionButton, padding: "2px 22px" }}
                        onClick={handleBack}
                    >
                        Back
                    </button>
                </div>
            )}
            {showAlertDialog && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(204, 204, 204, 0.5)',
                    zIndex: 9999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    pointerEvents: isDragging ? 'all' : 'auto'
                }}>
                    <div style={{
                        width: '506px',
                        height: '246px',
                        backgroundImage: `url(${alert_A_bg})`,
                        backgroundRepeat: 'no-repeat',
                        position: 'relative',
                        fontFamily: 'Tahoma',
                        fontSize: '14px',
                        color: 'white',
                        userSelect: 'none',
                        transform: `translate(${alertPos.x}px, ${alertPos.y}px)`
                    }}>
                        <div
                            onMouseDown={handleAlertMouseDown}
                            style={{
                                width: '100%',
                                height: '30px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                paddingLeft: '15px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                position: 'relative',
                                cursor: isDragging ? 'move' : 'move'
                            }}
                        >
                            Warning
                            <img
                                src={alert_close_n}
                                alt="Close"
                                onClick={() => setShowAlertDialog(false)}
                                onMouseDown={(e) => e.stopPropagation()}
                                style={{
                                    position: 'absolute',
                                    right: '15px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer'
                                }}
                            />
                        </div>

                        <div style={{
                            height: '145px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '0 20px',
                            color: 'black',
                            overflowY: 'auto',
                            textAlign: 'center'
                        }}>
                            <div dangerouslySetInnerHTML={{ __html: alertMessage }} />
                        </div>

                        <div style={{
                            height: '70px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <img
                                src={isOkHovered ? ok_o : ok_n}
                                alt="OK"
                                style={{ cursor: 'pointer' }}
                                onMouseEnter={() => setIsOkHovered(true)}
                                onMouseLeave={() => setIsOkHovered(false)}
                                onClick={() => setShowAlertDialog(false)}
                            />
                        </div>
                    </div>
                </div>
            )}

            {shareConfirmation && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.3)', zIndex: 1200,
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                    <div style={{
                        backgroundImage: `url(${alert_T_bg_medium})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: '100% 100%',
                        width: '406px',
                        height: '246px',
                        position: 'relative',
                        fontFamily: 'Arial, sans-serif'
                    }}>
                        <div style={{
                            position: 'absolute',
                            height: '30px',
                            width: '100%',
                            textAlign: 'center',
                            color: 'white',
                            paddingTop: '8px',
                            fontSize: '13px'
                        }}>
                            Confirm
                        </div>
                        <img
                            src={alert_close_n}
                            alt="Close"
                            onMouseOver={(e) => e.currentTarget.src = alert_close_o}
                            onMouseOut={(e) => e.currentTarget.src = alert_close_n}
                            onClick={() => setShareConfirmation(null)}
                            style={{ position: 'absolute', top: '0px', right: '0px', cursor: 'pointer' }}
                        />
                        <div style={{
                            position: 'absolute',
                            top: shareConfirmation === 'link' ? '45%' : '34%',
                            left: '0',
                            right: '0',
                            transform: 'translateY(-50%)',
                            textAlign: 'center',
                            color: '#000000',
                            fontSize: '14px'
                        }}>
                            {shareConfirmation === 'link' ? 'Do you want to Share Link?' : 'Have you answered Question?'}
                        </div>
                        {shareConfirmation === 'currentScreen' && (
                            <fieldset style={{
                                position: 'absolute',
                                top: '48%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                border: 0,
                                padding: 0,
                                display: 'flex',
                                gap: '16px'
                            }}>
                                <label>
                                    <input
                                        type="radio"
                                        name="current-screen-answered"
                                        checked={currentScreenAnswered}
                                        onChange={() => setCurrentScreenAnswered(true)}
                                    />
                                    Yes
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        name="current-screen-answered"
                                        checked={!currentScreenAnswered}
                                        onChange={() => setCurrentScreenAnswered(false)}
                                    />
                                    No
                                </label>
                            </fieldset>
                        )}
                        <div style={{
                            position: 'absolute',
                            bottom: '24px',
                            left: '0',
                            right: '0',
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '16px'
                        }}>
                            {shareConfirmation === 'link' ? (
                                <>
                                    <button type="button" onClick={() => void submitWhiteboardLink()}>Yes</button>
                                    <button type="button" onClick={() => setShareConfirmation(null)}>No</button>
                                </>
                            ) : (
                                <>
                                    <img
                                        src={okv_n}
                                        alt="OK"
                                        onClick={() => void openCurrentScreen()}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <img
                                        src={cancelv_n}
                                        alt="Cancel"
                                        onClick={() => setShareConfirmation(null)}
                                        style={{ cursor: 'pointer' }}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {showEmailConfirmDialog && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.3)', zIndex: 1100,
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                    <div style={{
                        backgroundImage: `url(${alert_T_bg_medium})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: '100% 100%',
                        width: '406px',
                        height: '246px',
                        position: 'relative',
                        fontFamily: 'Arial, sans-serif'
                    }}>
                        <div style={{
                            position: 'absolute',
                            height: '30px',
                            width: '100%',
                            textAlign: 'center',
                            color: 'white',
                            paddingTop: '8px',
                            fontSize: '13px',
                        }}>
                            Confirm
                        </div>

                        <img
                            src={alert_close_n}
                            alt="Close"
                            onMouseOver={(e) => e.currentTarget.src = alert_close_o}
                            onMouseOut={(e) => e.currentTarget.src = alert_close_n}
                            onClick={() => {
                                setShowEmailConfirmDialog(false);
                                setSelectedEmailSubject(null);
                            }}
                            style={{
                                position: 'absolute',
                                top: '0px',
                                right: '0px',
                                cursor: 'pointer'
                            }}
                        />

                        <div style={{
                            position: 'absolute',
                            top: '40%',
                            left: '0',
                            right: '0',
                            transform: 'translateY(-50%)',
                            textAlign: 'center',
                            color: '#000000',
                            fontSize: '14px',
                            padding: '0 20px'
                        }}>
                            {/* Do you want to send a mail for {selectedEmailSubject}? */}
                            Do you want to send a mail
                        </div>

                        <div style={{
                            position: 'absolute',
                            bottom: '20px',
                            left: '0',
                            right: '0',
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '20px'
                        }}>
                            <img
                                src={isNowHovered ? Now_o : Now_n}
                                alt="Yes"
                                onMouseEnter={() => setIsNowHovered(true)}
                                onMouseLeave={() => setIsNowHovered(false)}
                                onClick={handleSendEmail}
                                style={{ cursor: 'pointer' }}
                            />
                            <img
                                src={isLaterHovered ? Later_o : Later_n}
                                alt="No"
                                onMouseEnter={() => setIsLaterHovered(true)}
                                onMouseLeave={() => setIsLaterHovered(false)}
                                onClick={() => {
                                    setShowEmailConfirmDialog(false);
                                    setSelectedEmailSubject(null);
                                }}
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                    </div>
                </div>
            )}
            {showMDTimeConfirm && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.3)', zIndex: 1100,
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                    <div style={{
                        backgroundImage: `url(${alert_T_bg_medium})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: '100% 100%',
                        width: '406px',
                        height: '246px',
                        position: 'relative',
                        fontFamily: 'Arial, sans-serif'
                    }}>

                        <div style={{
                            position: 'absolute',
                            height: '30px',
                            width: '100%',
                            textAlign: 'center',
                            color: 'white',
                            paddingTop: '8px',
                            fontSize: '13px',
                        }}>
                            Time Based
                        </div>

                        <img
                            src={alert_close_n}
                            alt="Close"
                            onMouseOver={(e) => e.currentTarget.src = alert_close_o}
                            onMouseOut={(e) => e.currentTarget.src = alert_close_n}
                            onClick={() => setShowMDTimeConfirm(false)}
                            style={{
                                position: 'absolute',
                                top: '0px',
                                right: '0px',
                                cursor: 'pointer'
                            }}
                        />

                        <div style={{
                            position: 'absolute',
                            top: '40%',
                            left: '0',
                            right: '0',
                            transform: 'translateY(-50%)',
                            textAlign: 'center',
                            color: '#000000',
                            fontSize: '14px',
                            padding: '0 20px'
                        }}>
                            Want to assign Maths Doctor ?
                        </div>

                        <div style={{
                            position: 'absolute',
                            bottom: '20px',
                            left: '0',
                            right: '0',
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '20px'
                        }}>
                            <img
                                src={isNowHovered ? Now_o : Now_n}
                                alt="Now"
                                onMouseEnter={() => setIsNowHovered(true)}
                                onMouseLeave={() => setIsNowHovered(false)}
                                onClick={() => proceedWithAssignMD('NOW')}
                                style={{ cursor: 'pointer' }}
                            />

                            <img
                                src={isLaterHovered ? Later_o : Later_n}
                                alt="Later"
                                onMouseEnter={() => setIsLaterHovered(true)}
                                onMouseLeave={() => setIsLaterHovered(false)}
                                onClick={() => proceedWithAssignMD('LATER')}
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                    </div>
                </div>
            )}
            {showECTimeConfirm && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.3)', zIndex: 1100,
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                    <div style={{
                        backgroundImage: `url(${alert_T_bg_medium})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: '100% 100%',
                        width: '406px',
                        height: '246px',
                        position: 'relative',
                        fontFamily: 'Arial, sans-serif'
                    }}>

                        <div style={{
                            position: 'absolute',
                            height: '30px',
                            width: '100%',
                            textAlign: 'center',
                            color: 'white',
                            paddingTop: '8px',
                            fontSize: '13px',
                        }}>
                            Time Based
                        </div>

                        <img
                            src={alert_close_n}
                            alt="Close"
                            onMouseOver={(e) => e.currentTarget.src = alert_close_o}
                            onMouseOut={(e) => e.currentTarget.src = alert_close_n}
                            onClick={() => setShowECTimeConfirm(false)}
                            style={{
                                position: 'absolute',
                                top: '0px',
                                right: '0px',
                                cursor: 'pointer'
                            }}
                        />

                        <div style={{
                            position: 'absolute',
                            top: '40%',
                            left: '0',
                            right: '0',
                            transform: 'translateY(-50%)',
                            textAlign: 'center',
                            color: '#000000',
                            fontSize: '14px',
                            padding: '0 20px'
                        }}>
                            Want to assign English Check ?
                        </div>

                        <div style={{
                            position: 'absolute',
                            bottom: '20px',
                            left: '0',
                            right: '0',
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '20px'
                        }}>
                            <img
                                src={isNowHovered ? Now_o : Now_n}
                                alt="Now"
                                onMouseEnter={() => setIsNowHovered(true)}
                                onMouseLeave={() => setIsNowHovered(false)}
                                onClick={() => proceedWithAssignEC('NOW')}
                                style={{ cursor: 'pointer' }}
                            />

                            <img
                                src={isLaterHovered ? Later_o : Later_n}
                                alt="Later"
                                onMouseEnter={() => setIsLaterHovered(true)}
                                onMouseLeave={() => setIsLaterHovered(false)}
                                onClick={() => proceedWithAssignEC('LATER')}
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const HistoryList = React.memo(({ tasks, onStatusChange, onOpenAttachments }: {
    tasks: Task[],
    onStatusChange: (id: number, status: boolean) => void,
    onOpenAttachments: (task: Task) => void
}) => {
    return (
        <table style={{ width: '100%' }}>
            <tbody>
                {tasks && tasks.length > 0 ? tasks.map((task, index) => (
                    <React.Fragment key={task.problemId || index}>
                        <tr>
                            <td colSpan={9} style={{ borderTop: index > 0 ? '1px solid #0000ff' : 'none', paddingTop: '10px' }}>
                                <span style={{ color: 'red', textDecoration: 'underline', fontWeight: 'bold' }}>
                                    Support - {tasks.length - index}
                                </span>
                                &nbsp;&nbsp;&nbsp;{enteredFormatDate(task.enteredDate)}
                            </td>
                        </tr>
                        <tr>
                            <td
                                className="history-description-cell"
                                style={{
                                    width: '35%',
                                    padding: '3px',
                                    verticalAlign: 'middle',
                                    color: '#000000',
                                    whiteSpace: 'normal',
                                    overflowWrap: 'anywhere',
                                    wordBreak: 'break-word'
                                }}
                                dangerouslySetInnerHTML={{ __html: task.description }}
                            />
                            <td style={{ width: '7%', padding: '3px', verticalAlign: 'top' }}>{task.from?.split(' ')[0]}</td>
                            <td style={{ width: '10%', padding: '3px', verticalAlign: 'top' }}>{task.to}</td>
                            <td style={{ width: '9%', padding: '3px', verticalAlign: 'top' }}>{formatDate(task.actionDate)}</td>

                            <td style={{ width: '2%', padding: '3px', verticalAlign: 'top', textAlign: 'left' }}>
                                <input type="checkbox" checked={task.isFixed}
                                    onChange={() => onStatusChange(task.problemId, task.isFixed)}
                                />
                            </td>

                            <td style={{ width: '15%', paddingRight: '35px', verticalAlign: 'top', textAlign: "center" }}>
                                {task.type && <div>Type - {task.type}</div>}
                                {task.reason && <div>(Reason - {task.reason})</div>}
                                {task.outcome && <div>{task.outcome}</div>}
                            </td>

                            <td style={{ width: '8%', padding: '3px' }}>
                                {task.timeSpent ? `Time - ${task.timeSpent}` : 'NA'}
                            </td>
                            <td style={{ width: '6%' }}>
                                {task.hasAttachment && (
                                    <button
                                        type="button"
                                        onClick={() => onOpenAttachments(task)}
                                        style={{ color: 'blue', cursor: 'pointer', border: 0, padding: 0, background: 'none' }}
                                    >
                                        <img src={btnAttachment} alt="Attach" style={{ cursor: 'pointer' }} />

                                    </button>
                                )}
                            </td>
                        </tr>
                        <tr><td colSpan={9} style={{ height: '10px' }}></td></tr>
                    </React.Fragment>
                )) : (
                    <tr><td colSpan={9} style={{ padding: '10px', textAlign: 'center' }}>No tasks found</td></tr>
                )}
            </tbody>
        </table>
    );
}, (prevProps, nextProps) => {
    return prevProps.tasks === nextProps.tasks;
});

export default EL_AddEditTask;